import { useCallback } from 'react';
import { useModal } from '@/hooks/useModal.hook';
import { useProfile } from '@/hooks/useProfile.hook';
import { Providers } from '@/types/providers.type';
import {
  useDiscordControllerDisconnectMutation,
  useGithubControllerDisconnectMutation,
  useGoogleControllerDisconnectMutation,
  useSpotifyControllerDisconnectMutation,
  useRedditControllerDisconnectMutation,
  useSteamControllerDisconnectMutation,
  useTelegramControllerDisconnectMutation,
  useTwitterControllerDisconnectMutation,
  useWalletControllerDisconnectWalletMutation,
} from '@/store/services/MidleNestApi.service';
import { useTaskQue } from '@/hooks/useTaskQue.hook';
import { useProviderAccount } from '@/hooks/useProviderAccount';

export const useConnectAccount = (id: string) => {
  const { showModal } = useModal();
  const { profile, reloadProfile } = useProfile();
  const { account: twitter } = useProviderAccount('twitter');
  const { account: telegram } = useProviderAccount('telegram');
  const { account: discord } = useProviderAccount('discord');
  const { account: github } = useProviderAccount('github');
  const { account: google } = useProviderAccount('google');
  const { account: wallet } = useProviderAccount('wallet');
  const { account: steam } = useProviderAccount('steam');
  const { account: reddit } = useProviderAccount('reddit');
  const { account: spotify } = useProviderAccount('spotify');

  const [walletDisconnect] = useWalletControllerDisconnectWalletMutation();
  const [githubDisconnect] = useGithubControllerDisconnectMutation();
  const [twitterDisconnect] = useTwitterControllerDisconnectMutation();
  const [discordDisconnect] = useDiscordControllerDisconnectMutation();
  const [googleDisconnect] = useGoogleControllerDisconnectMutation();
  const [telegramDisconnect] = useTelegramControllerDisconnectMutation();
  const [steamDisconnect] = useSteamControllerDisconnectMutation();
  const [redditDisconnect] = useRedditControllerDisconnectMutation();
  const [spotifyDisconnect] = useSpotifyControllerDisconnectMutation();

  // const [telegramConnect] = usePostApiV1TelegramTelegramconnectMutation();
  // const [telegramDisconnect] = usePostApiV1TelegramTelegramdisconnectMutation();

  const { isWaiting, isCompleted, setIsWaiting, setIsCompleted, removeFromWaiting } =
    useTaskQue(id);

  const connectMetamask = () => {
    showModal('wallet-connection');
  };
  const disconnectMetamask = () => {
    walletDisconnect({ id: wallet?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const connectTwitter = () => {
    window.open('/connect/twitter', '_blank');
  };

  const disconnectTwitter = () => {
    twitterDisconnect({ id: twitter?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const connectDiscord = () => {
    window.open('/connect/discord', '_blank');
  };

  const connectSteam = () => {
    window.open('/connect/steam', '_blank');
  };

  const disconnectSteam = () => {
    steamDisconnect({ id: steam?.identity || '' }).then(() => {
      reloadProfile();
    });
  };
  const connectReddit = () => {
    window.open('/connect/reddit', '_blank');
  };

  const disconnectReddit = () => {
    redditDisconnect({ id: reddit?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const disconnectDiscord = () => {
    discordDisconnect({ id: discord?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const connectTelegram = () => {
    window.open('/connect/telegram', '_blank');
  };
  const disconnectTelegram = () => {
    telegramDisconnect({ id: telegram?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const connectGithub = () => {
    window.open('/connect/github', '_blank');
  };
  const disconnectGithub = () => {
    githubDisconnect({ id: github?.identity || '' }).then(() => {
      reloadProfile();
    });
  };
  const connectGoogle = () => {
    window.open('/connect/google', '_blank');
  };

  const disconnectGoogle = () => {
    googleDisconnect({ id: google?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const connectSpotify = () => {
    window.open('/connect/spotify', '_blank');
  };
  const disconnectSpotify = () => {
    spotifyDisconnect({ id: spotify?.identity || '' }).then(() => {
      reloadProfile();
    });
  };

  const isConnected = useCallback(
    (desiredProvider: Providers) => {
      const provider = profile?.user?.accounts.find((data) => data.provider === desiredProvider);
      return !!provider?.identity;
    },
    [profile],
  );

  const connect = {
    twitter: connectTwitter,
    telegram: connectTelegram,
    discord: connectDiscord,
    github: connectGithub,
    wallet: connectMetamask,
    google: connectGoogle,
    steam: connectSteam,
    spotify: connectSpotify,
    reddit: connectReddit,
  };

  const disconnect = {
    twitter: disconnectTwitter,
    telegram: disconnectTelegram,
    discord: disconnectDiscord,
    github: disconnectGithub,
    wallet: disconnectMetamask,
    google: disconnectGoogle,
    steam: disconnectSteam,
    spotify: disconnectSpotify,
    reddit: disconnectReddit,
  };

  return { connect, disconnect, isConnected };
};
